module.exports = __webpack_public_path__ + "static/Group 3608@2x-b78eb300bbbbb8641aa794d995f727a9.png";